import { atom, useAtom } from "jotai";
import { defaultLocation } from "./constants";
import type { GoogleLatLngLiteral } from "./types";

interface MapsControl {
    searchBoxAutofill: string;
    camera: {
        center: GoogleLatLngLiteral;
        zoom: number;
    };
}

export const mapControlAtom = atom<MapsControl>({
    searchBoxAutofill: "",
    camera: {
        center: defaultLocation,
        zoom: 10,
    },
});

export const useMapControlAtomState = () => useAtom(mapControlAtom);
